interface Balances {
    positive: string,
    negative: string;
}

export const balanceFunction = (data: string): Balances => {
    const i: number = data.indexOf("/");
    const resp: Balances = { positive: data.substr(0, i - 1), negative: data.substr(i + 1, data.length) }
    return resp;
};